import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const NotificationLabelIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        viewBox="0 0 16 16"
        className="Icon notification-label"
        {...props}
    >
        <path
            fill="#fff"
            d="M7.633.005a4.251 4.251 0 0 1 2.794 1.24l4 4a4.25 4.25 0 0 1 0 6.01l-3.172 3.172a4.25 4.25 0 0 1-6.01 0l-4-4a4.251 4.251 0 0 1-1.24-2.794L0 7.422V3.25A3.25 3.25 0 0 1 3.25 0h4.172l.21.005Z"
        />
        <path
            fill="#8D929A"
            d="M6.188 4a2.188 2.188 0 1 1 0 4.375 2.188 2.188 0 0 1 0-4.375Zm-.313 1a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z"
        />
        <path
            fill="#fff"
            d="M2.25 3.25a1 1 0 0 1 1-1h4.172a2 2 0 0 1 1.414.586l4 4a2 2 0 0 1 0 2.828l-3.172 3.172a2 2 0 0 1-2.828 0l-4-4a2 2 0 0 1-.586-1.414V3.25Z"
        />
        <path
            fill="#A3A7AE"
            d="M7.422 1a3.25 3.25 0 0 1 2.298.952l4 4a3.25 3.25 0 0 1 0 4.596l-3.172 3.172a3.25 3.25 0 0 1-4.596 0l-4-4A3.25 3.25 0 0 1 1 7.422V3.25A2.25 2.25 0 0 1 3.25 1v1.25a1 1 0 0 0-1 1v4.172l.01.197a2 2 0 0 0 .576 1.217l4 4a2 2 0 0 0 2.677.137l.151-.137 3.172-3.172a2 2 0 0 0 .137-2.677l-.137-.151-4-4a2 2 0 0 0-1.217-.576l-.197-.01V1Zm0 0v1.25H3.25V1h4.172Z"
        />
        <path fill="#A3A7AE" d="M6 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Z" />
    </svg>
);
const Memo = memo(NotificationLabelIcon);
export default Memo;
